/* eslint no-use-before-define: 0 */
/* tslint:disable */
const message = {
        "Sign in": "Se connecter",
        "Upload sample": "Télécharger un exemple",
        "Welcome": "Bienvenue",
        "Loading...": "Chargement...",
        "Step 1. Description": "Étape 1. Description",
        "Add a project name and give instructions on your project.": "Ajouter un nom de projet et donnez des instructions sur votre projet.",
        "Step 2. Task": "Étape 2. Tâche",
        "Select a type of the task for your project.": "Sélectionner un type de tâche pour votre projet.",
        "+ Add new class": "+ Ajouter une nouvelle classe",
        "+ Add new entity": "+ Ajouter une nouvelle entité",
        "Each tag consists of a value. You can use tags to search and filter your resources.": "Chaque balise est constituée d'une clé et valeur. Vous pouvez utiliser des balises pour rechercher et filtrer vos ressources.",
        "Step 5. Tags": "Étape 5. Balises",
        "Tags": "Balises",
        "Name, tags ,task and class or entities required": "Nom, balises, tâche et classes ou entités requises",
        "classification": "classification",
        "Class": "Classes",
        "Entities": "Entités",
        "Select a “classification” type of the task in case you`d like to identify the “class” your images fall under.": "Sélectionner classification comme tâche au cas où vous voudriez identifier les classes ou les balises de vos images.",
        "Select a “detection” type of the task in case you`d like to locate an object in an image with respect to the background. ": "Sélectionner détection comme tâche au cas où vous voudriez localiser un objet dans une image par rapport à l'arrière-plan. ",
        "Classification": "Classification",
        "Task": "Tâche",
        "Description": "Description",
        "Enter your name": "Entrez votre nom",
        "* Adding a project name is a required fiield. ": "* Le nom du projet est un champ obligatoire. ",
        "Name (*)": "Nom (*)",
        "detection": "détection",
        "Detection": "Détection",
        "Object detection": "Détection d'objet",
        "No Documents were found related to this request": "Aucun document lié à cette demande n'a été trouvé",
        "Color": "Couleur",
        "Name": "Nom",
        "Type": "Type",
        "Add a name of the class and select the color of the element.": "Ajouter des classes et sélectionner une couleur pour chaque classe.",
        "Add a name of the entity and select the color of the element.": "Ajouter des entités et sélectionner une couleur pour chaque entité.",
        "Create project": "Créer le projet",
        "Upload please image png, svg+xml, jpeg, jpg types!": "Télécharger s'il vous plaît image png, svg + xml, jpeg, jpg types!",
        "Name you entered already exist please try with different name!": "Le nom que vous avez entré existe déjà, veuillez essayer avec un autre nom !",
        "Please add name!": "Veuillez ajouter un nom !",
        "Confirm password required": "Confirmer le mot de passe requis",
        "Confirm password": "Confirmez le mot de passe",
        "Step 1. Path": "Étape 1. API",
        "Computer Vision Enterprise AI": "Vision par ordinateur IA pour des entreprises en quête d'automatisation disruptive",
        "Passwords not matching": "Les mots de passe ne correspondent pas",
        "Step 2. Task": "Étape 2. Tâche",
        "Step 2. Documents": "Étape 2. Documents",
        "Step 3. Labeling data": "Étape 3. Étiquetage des données",
        "Step 4. Synthetic data": "Étape 4. Données synthétiques",
        "Step 5. Standardisation": "Étape 5. Normalisation",
        "Step 6. Capacity management": "Étape 6. Gestion de la capacité",
        "Step 7. Tags": "Étape 7. Balises",
        "Step 8. Preview": "Étape 8. Aperçu",
        "AI solution already approved by": "Solution IA déjà approuvée par",
        "View your datset details.": "Afficher les détails de votre jeu de données.",
        "Manage capacity of machine for your dataset": "Gérer la capacité de la machine pour votre jeu de données",
        "Standardisation feature allow to harmonize entities name and class name, avoid duplicate entities or class name or remove some elements you do not need for training.": "La fonction de normalisation permet d'harmoniser les noms des entités et les noms des classes, afin d'éviter les doublons ou de supprimer certains éléments dont vous n'avez pas besoin pour la formation du modèle IA.",
        "Select your generated data.": "Sélectionner vos données générées.",
        "Select your labelling data.": "Sélectionner vos données d étiquetéés.",
        "Type of dataset": "Tâche",
        "Labeling data": "Données étiquetéés",
        "Synthetic data": "Données synthétiques",
        "Standardisation": "Normalisation",
        "Capacity management": "Gestion de la capacité",
        "Preview": "Aperçu",
        "already exist": "existe déjà",
        "We recommend that you do use a small machine if your dataset contains only real data.": "Nous vous recommandons d'utiliser une petite machine si votre jeu de données ne contient que des données étiquetées.",
        "Its not possible to update this information during data processing": "Il n est pas possible de mettre à jour ces informations pendant le traitement des données",
        "Machine 4 GiB memory size for small dataset without synthetic data on 4 workers": "Taille de la mémoire de la machine de 4 Gio pour un petit jeu de données sans données synthétiques sur 4 travailleurs",
        "Machine 8 GiB memory size for medium dataset with synthetic data on 8 workers": "Taille de la mémoire de la machine de 8 Gio pour un jeu de données moyen avec des données synthétiques sur 8 travailleurs",
        "Machine 16 GiB memory size for big dataset with major part synthetic data on 16 workers": "Taille de la mémoire de la machine de 16 Gio pour le grand jeu de données avec la majeure partie des données synthétiques sur 16 travailleurs",
        "Small": "Petite",
        "Medium": "Moyen",
        "Large": "Grande",
        "Machine capacity for your dataset.": "Capacité de la machine pour votre jeu de données.",
        "Machine size": "Taille de la machine",
        "Server execution time for your dataset processing.": "Temps d exécution du serveur pour le traitement de votre jeu de données.",
        "Timeout": "Temps d'exécution",
        "+ add field for rename or skip": "+ Ajouter un champ",
        "Add field": "Ajouter le champ",
        "new key": "Nouvelle clé",
        "key": "Clé",
        "+ Add Scene": "+ Ajouter une scène",
        "Select Scene": "Sélectionner une scène",
        "Scenes": "Scènes",
        "* Specify the total number of images you expect for generation.": "* Spécifiez le nombre total d'images que vous attendez pour la génération.",
        "Total images": "Nombre d'images à générer",
        "If you plan to use only synthetic data for this dataset, we advise you to set 20% for test rate and if you plan to create dataset with both synthetic data and labelling data we advise you to set 20% or 0% for test rate.": "Si vous prévoyez d'utiliser uniquement des données synthétiques pour cet jeu de données, nous vous conseillons de définir 20 % pour le taux de test et si vous prévoyez de créer un jeu de données avec à la fois des données synthétiques et des données d'étiquetage, nous vous conseillons de définir 20 % ou 0 % pour le taux de test.",
        "* Indicate the number of images for testing.": "* Indiquez le nombre d'images à tester.",
        "Test rate percentage (%)": "Taux de pourcentage pour le test (%)",
        "Enter your count": "Entrez votre compte",
        "Data annotated without unvalidated": "Images annotées sans les non validées",
        "Data annotated and validated": "Images annotées et validées",
        "Data annotated": "Images annotées",
        "Apply filter on your dataset": "Appliquer un filtre sur votre jeu de données",
        "Activate option croping for table document": "Activer l'option de recadrage pour le document tableau",
        "Table dataset": "Jeux de données de type table",
        "Remove duplicate images on your dataset": "Supprimer les images en double sur votre jeu de données",
        "Remove duplicate": "Supprimer les images en doublon",
        "We estimate the total labelling is arround": "Nous estimons que l'étiquetage total est d'environ",
        "+ Add labeling": "+ Ajouter un projet d'étiquetage",
        "Select Project": "Sélectionner un projet",
        "Project labeling": "Projet d'étiquetage",
        "* Indicate the quantity of data you expect on your dataset. 0 equal unlimit.": "* Indiquez la quantité de données que vous attendez sur votre jeu de données. 0 égal illimité.",
        "Limitation": "Limitation",
        "If you plan to use only labelling data for this dataset, we advise you to set 20% for test rate and if you plan to create dataset with both synthetic data and labelling data we advise you to set 80% or 100% for test rate.": "Si vous prévoyez d'utiliser uniquement des données d'étiquetage pour cet jeu de données, nous vous conseillons de définir 20 % pour le taux de test et si vous prévoyez de créer un jeu de données avec à la fois des données synthétiques et des données d'étiquetage, nous vous conseillons de définir 80 % ou 100 % pour le taux de test.",
        "Select a type of your dataset.": "Sélectionner un type de votre jeu de données.",
        "💡 Each JSON file is linked with each image.": "💡 Chaque fichier JSON sera lié à chaque image extraite.",
        "For document classification or document extraction key-pairs values, you can prepare OCR text extraction to write in JSON files containing all texts blocks for pre-processing training model. 📝": "Pour les formations pour la classification de document ou d'extraction de mots clés, vous pouvez préparer l'extraction de texte OCR qui sera écrit dans des fichiers JSON contenant tous les blocs de texte pour la formation. 📝",
        "OCR processing detection": "Préparer le traitement du texte OCR pour votre future formation",
        "OCR processing classification": "Préparer le traitement du texte OCR pour votre future formation",
        "Select a “detection” type in case you want to locate an object in an image with respect to the background.": "Sélectionner un type de « détection » si vous souhaitez localiser un objet dans une image par rapport à l'arrière-plan.",
        "Select a “classification” type in case you want to identify the “class’ your images fall under.": "Sélectionner un type de « classification » au cas où vous voudriez identifier la « classes » de vos images.",
        "Add a dataset name and an optional desription for your dataset.": "Ajouter un nom et une description pour votre jeu de données.",
        "* Adding a dataset name is a required field. ": "* Le nom de jeu de données est obligatoire.",
        "labelClass": "labelClass",
        "Scenes are Failed to scane": "Échec de la numérisation des scènes",
        "Scenes are scanned successfully": "Les scènes sont numérisées avec succès",
        "Scanning :": "Numérisation :",
        "Scane projects scene": "Scène de projets Scane",
        "Sorry, not able to generate your dataset. Please try again later or contact support.": "Désolé, impossible de générer votre jeu de données. Veuillez réessayer ultérieurement ou contacter l assistance.",
        "Sorry, not able to generate your dataset. Please try again later.": "Désolé, impossible de générer votre jeu de données. Veuillez réessayer plus tard.",
        "Please select valid scene": "Veuillez sélectionner une scène valide",
        "is not valid scene please with different scene or fix this scene.": "n est pas une scène valide, veuillez utiliser une scène différente ou corriger cette scène.",
        "Add a name and an optional description for your labelling data.": "Ajouter un nom et une description facultative pour vos données d'étiquetage.",
        "Enter Description": "Entrer une description",
        "Name and preset required": "Nom et magasin de données requis",
        "Preset": "Magasin de données",
        "Select data store": "Sélectionner le magasin de données",
        "Step 2. data store": "Étape 2. magasin de données",
        "Select preset data collection to start your labelling.": "Sélectionner un magasin de données prédéfinie pour commencer votre étiquetage.",
        "sorry, thresh hold only can between 0 to 100": "désolé, le seuil d'acceptance ne peut être compris qu entre 0 et 100",
        "All inputs need to be filled!": "Toutes les entrées doivent être remplies !",
        "* Adding a preset name is a required filed.": "* Le nom d'un magasin de données est obligatoire.",
        "Add a preset name and an optional description for your preset.": "Ajouter un nom et une description pour votre magasin.",
        "Image pre-processingwith PNG, JPEG or PDF": "Prétraitement d'image avec PNG, JPEG ou PDF",
        "Text pre-processing with CSV format": "Prétraitement de texte au format CSV",
        "Select a type of your preset.": "Sélectionner le type de répertoire.",
        "Step 3. Tags": "Étape 3. Balises",
        "Name and background required": "Nom et parcours requis",
        "Add your synthetic data name and an optional description for your data": "Ajouter un nom et une description pour votre scène",
        "Background": "Arrière-plan",
        "Image": "Image",
        "Blank": "Vierge",
        "Width": "Largeur",
        "Height": "Hauteur",
        "Accounting": "Comptabilité",
        "Identity": "Identité",
        "Insurance": "Assurance",
        "Loan": "Prêt et services financiers",
        "Immobilier": "Immobilier",
        "Other": "Autre",
        "Background color": "Couleur de l'arrière plan",
        "Background image": "Image de fond",
        "Step 2. Background": "Étape 2. Contexte",
        "Select a background for your scene. You can leave the background blank or you can upload an image which will be the background for your scene.": "Sélectionner un arrière-plan pour votre scène. Vous pouvez laisser l'arrière-plan vide ou télécharger une image qui servira d'arrière-plan à votre scène.",
        "Please image uploaded need be less than 1mb": "S il vous plaît, l image téléchargée doit être inférieure à 1 Mo",
        "Name, description of your dataset": "Nom et description de votre jeu de données",
        "Predicts all the correct tags you want to assign to an image": "Prédire toutes les balises correctes que vous souhaitez attribuer à une image ou à un document",
        "Predicts all the locations of items that interest you": "Prédire tous les emplacements des objets qui vous intéressent sur l'image et le document",
        "Classify your dataset": "Classer votre jeu de données",
        "Zip File": "Fichier zip",
        "Zip": "Zipper",
        "URL": "URL",
        "Upload file (ZIP Format)": "Téléchargez le fichier (format ZIP)",
        "Upload zip file": "Télécharger le fichier zip",
        "Please, you need to use compatible dataset in zip file. Please follow our documentation for compatibility on classification and detection": "S il vous plaît, vous devez utiliser un jeu de données compatible dans le fichier zip. Veuillez suivre notre documentation pour la compatibilité sur la classification et la détection",
        "Add your URL": "Ajouter votre URL",
        "Enter your URL": "Entrez votre URL",
        "Step 3. Zip File": "Étape 3. Fichier Zip",
        "Upload already existing dataset": "Télécharger un jeu de données déjà existant",
        "View your model details and create the model.": "Affichez les détails de votre modèle.",
        "It may take 2-15 minutes to start the training": "L'allocation d'une machine peut prendre environ 2 à 10 minutes pour votre entrainement",
        "- Capacty machine 16 or 32 GiB memory, NVIDIA T4 Tensor Core (16 GiB GPU memory)": "- Capacité machine 16 ou 32 Go de mémoire, NVIDIA T4 Tensor Core (mémoire GPU 16 Go)",
        "- Capacty machine 64 GiB memory, NVIDIA T4 Tensor Core (16 GiB GPU memory)": "- Capacité machine 64 Go de mémoire, NVIDIA T4 Tensor Core (mémoire GPU 16 Go)",
        "- Capacty machine 61 GiB memory, Faster GPU NVIDIA V100 (16 GiB GPU memory)": "- Capacité machine 61 Go de mémoire, GPU NVIDIA V100 (mémoire GPU 16 Go)",
        "Its not possible to update this information during training": "Il n est pas possible de mettre à jour ces informations pendant la formation",
        "We recommend that you do use a small machine if your train GNN task or for proof of concept model": "Nous vous recommandons d'utiliser une petite machine si votre tâche d'entraînement est une approche GNN ou pour les modèles de preuve de concept",
        "Machine capacity for model.": "Capacité de la machine pour le modèle.",
        "Server execution time for training model runtime.": "Temps d'exécution du serveur pour la formation du modèle.",
        "Manage capacity of machine for your model": "Gérer la capacité de la machine pour votre modèle",
        "Initialize the pre-trained model from the previous model": "Initialiser un entrainement à partir d'un modèle précédent",
        "Transfer learning": "Apprentissage par transfert",
        "Only trains models successfull with checkpoints": "Attention, nous ne sélectionnons que des modèles avec des points de contrôle et un entrainement en statut terminé",
        "Select Train Epoch": "Sélectionner l'époque du train",
        "Checkpoint": "Point de contrôle",
        "Select Model": "Sélectionner un modèle",
        "Train Model": "Modèle",
        "Step 5. Transfer learning": "Étape 5. Apprentissage par transfert",
        "Specify a task, a number of epoches, a learning rate and a batch size of your model.": "Spécifiez une tâche, un nombre de point de contrôle, un taux d'apprentissage et une taille de lot de votre modèle.",
        "Specify your model and its training data, hyperparametres, data augmentation and evaluation metrics.": "Spécifier une configuration, des hyperparamètres, des augmentations de données et des métriques d'évaluation.",
        "Configuration": "Configuration",
        "Metrics": "Métriques",
        "Metrics  - they are numeric values used to evaluate the performance of the models. There are classification metrics (accuracy, precision, recall, etc.), regression metrics (MSE, MAE), ranking metrics (MRR, DCG, NDCG), and statistical metrics.": "Métriques - ce sont des valeurs numériques utilisées pour évaluer les performances des modèles. Il existe des métriques de classification (exactitude, précision, rappel, etc.), des métriques de régression (MSE, MAE), des métriques de classement (MRR, DCG, NDCG) et des métriques statistiques.",
        "Data augmantation": "Augmentation des données",
        "Data augmentation - is an image augmentation that turns out to be the result of geometric transformations, flipping, colour modification, cropping, rotation and random erasing.": "Augmentation de données - est une augmentation d image qui s avère être le résultat de transformations géométriques, de retournement, de modification de couleur, de recadrage, de rotation et d effacement aléatoire.",
        "Hyperparametres": "Hyperparamètres",
        "Hyperparametres - are parametres whose values are used to control the learning process.": "Hyperparamètres - sont des paramètres dont les valeurs sont utilisées pour contrôler le processus d apprentissage.",
        "Model": "Modèle",
        "Model - is a file that has been trained to recognise certain types of patterns.You train a model over a set of data, providing it an algorithm that it can use to reason over and learn from those data.": "Modèle - est un fichier qui a été formé pour reconnaître certains types de modèles. Vous formez un modèle sur un jeu de données, en lui fournissant un algorithme qu il peut utiliser pour raisonner et apprendre de ces données.",
        "+ Add": "+ Ajouter",
        "+ Add config": "+ Ajouter",
        "Batch size :": "Taille du lot :",
        "epoch must be between 50 to 200.": "l époque doit être comprise entre 50 et 200.",
        "Lr must be less than or equal to 1.": "Lr doit être inférieur ou égal à 1.",
        "*Optimize with learning rate": "* Optimiser avec le taux d apprentissage",
        "Learning Rate :": "Taux d apprentissage :",
        "Number": "Numéro",
        "*Specify the number of epochs for  your model.": "*Spécifiez le nombre d'époques pour votre modèle.",
        "Number of epochs": "Nombre d époques",
        "Model :": "Modèle :",
        "Task :": "Tâche :",
        "Expert": "Experte",
        "Basic": "Basique",
        "Step 4. Configuration": "Étape 4. Configuration",
        "Dataset": "Jeu de données",
        "Select one of the datasets for your model.": "Sélectionner un jeu de données pour votre modèle.",
        "Author :": "Auteur :",
        "Date created :": "Date de création :",
        "Download the logs": "Télécharger les journaux",
        "Logs :": "Journaux :",
        "Dataset URL :": "URL du jeu de données :",
        "Dataset created automatically (100)": "Jeu de données créé automatiquement (100)",
        "State :": "État :",
        "Status :": "Statut :",
        "Total images :": "Nombre total d images :",
        "Task type :": "Type de tâche :",
        "Tags :": "Balises :",
        "Description:": "Description:",
        "Name:": "Nom:",
        "Dataset*": "Jeu de données*",
        "Step 3. Dataset": "Étape 3. Jeu de données",
        "Add a model name and an optional description for your model.": "Ajouter un nom et une description pour votre modèle.",
        "view the image before testing the model.": "voir l image avant de tester le modèle.",
        "Upload preview image": "Vignette",
        "Step 2. Description": "Étape 2. Description",
        "Select a type of the task.": "Sélectionner un type de tâche.",
        "Step 1. Template": "Étape 1. Démarrer avec une pré-configuration",
        "+ Use template": "+ Utiliser cette configuration",
        "Classifies the documents basing both on the text and on the image.": "Classer des documents en se basant à la fois sur le texte et sur l'image.",
        "Classifies the documents basing on the text.": "Classer des documents en fonction du contenu textuel.",
        "Analyzes the image and identifies the “class” the image falls under.": "Analyser des images et identifier les « classes » à laquelle appartient chaque image.",
        "Locates interesting objects in an image with respect to the background.": "Localiser des objets intéressants dans une image par rapport à l'arrière-plan.",
        "Estimates the number of object instances in a single image...": "Estimer le nombre d'instances d'objets dans une seule image.",
        "Detects the predefined keys and values correspondingly.": "Détecte les clés et les valeurs prédéfinies en conséquence.",
        "Keys-pairs value detection": "Détection clés/valeurs",
        "Document classification (text and image)": "Classification des documents (texte et image)",
        "Document classification (text only)": "Classification des documents (texte uniquement)",
        "Image classification": "Classement des images",
        "Object counting": "Comptage d'objets",
        "Sorry, not able to train model. Please try again later.": "Désolé, impossible d entraîner le modèle. Veuillez réessayer plus tard.",
        "Train created successfully!": "Train créé avec succès !",
        "Sorry, not able to train model error on validation configuration. Please try again later or contact Wikibank.": "Désolé, impossible de former l erreur de modèle sur la configuration de validation. Veuillez réessayer ultérieurement ou contacter Wikibank.",
        "Configuration file is not valid": "Le fichier de configuration n est pas valide",
        "Sorry, Yaml is not valid. Please try again later or contact Wikibank.": "Désolé, Yaml n est pas valide. Veuillez réessayer ultérieurement ou contacter Wikibank.",
        "Search by name": "Rechercher par nom",
        "selected": "choisie",
        "Diselect All": "Tout sélectionner",
        "Delete": "Supprimer",
        "Item(s)": "Articles)",
        "No Data Found": "Aucune donnée disponible",
        "No data available": "Pas de données disponibles",
        "Show 30": "Afficher 30",
        "Show 50": "Afficher 50",
        "Show 100": "Afficher 100",
        "Copy": "Copier",
        "Transfer": "Transférer",
        "Download": "Télécharger",
        "Import a images": "Importer des images",
        "Import a files": "Importer des fichiers txt",
        "Delete similar file": "Supprimer les fichiers similaire",
        "Delete duplicate file": "Supprimer les doublons",
        "Export sample": "Exporter un échantillon",
        "Drop .csv, .txt files to upload": "Déposez les fichiers .csv, .txt à télécharger",
        "Drop PNG or JPG files to upload": "Déposez les fichiers PNG ou JPG à télécharger",
        "Cancel": "Annuler",
        "Select Preset": "Sélectionner le magasin de données",
        "Transfer To preset:": "Transférer vers un autre magasin de données :",
        "Files:": "Fichiers:",
        "Transfer Files": "Transfer Files",
        "Copy To preset:": "Copier vers un autre magasin de données :",
        "Copy Files": "Copier des fichiers",
        "Start": "Démarrer",
        "From": "Depuis",
        "Select your range page": "Sélectionner votre page de gamme",
        "Page": "Page",
        "Similar files": "Fichiers similaires",
        "To": "Pour",
        "Duplicate files": "Fichiers en double",
        "Sorry, not able to process this task. Please try again later or contact Wikibank.": "Désolé, impossible de traiter cette tâche. Veuillez réessayer ultérieurement ou contacter Wikibank.",
        "Successfull task created": "Tâche créée avec succès",
        "Files transfered successfully": "Fichiers transférés avec succès",
        "Files copied successfully": "Fichiers copiés avec succès",
        "image not created": "image non créée",
        "error ocurred": "erreur est survenue",
        "uploaded successfully": "téléchargé avec succès",
        "not uploaded": "non téléchargé",
        "Document not supported": "Document non pris en charge",
        "You cannot undo this once performed.": "Vous ne pouvez pas annuler cela une fois effectué.",
        "Transfer preset to another company": "Transférer le magasin de données vers un autre espace de travail",
        "Transfer all data": "Transférer toutes les données",
        "Transfer all data to another preset": "Transférer toutes les données vers un autre magasin de données",
        "Delete preset": "Supprimer le magasin de données",
        "Delete this preset": "Supprimer ce magasin de données",
        "Company:": "Espace de travail :",
        "Transfer preset": "Préréglage de transfert",
        "error in transfer company": "erreur dans l'espace de travail de transfert",
        "Prest moved to": "Prest a déménagé à",
        "successfully": "avec succès",
        "Preset transfered successfully": "Préréglage transféré avec succès",
        "updated successfully": "Mis à jour avec succés",
        "No data found": "Aucune donnée disponible",
        "Data store(s)": "Magasin(s) de données",
        "item(s)": "éléments)",
        "submit": "Soumettre",
        "Upload a zip": "Télécharger un fichier zip",
        "Import Classification": "Importation des données de classification",
        "Enter Name": "Entrer le nom",
        "Change status": "Modifier de statut",
        "Select status": "Sélectionner le statut",
        "Status changed successfully!": "Le statut a été modifié avec succès !",
        "Classes": "Classes",
        "Labeled": "Étiquetées",
        "Generated": "Générés",
        "Meta information": "Méta-information",
        "Type of task": "Type de tâche",
        "Objects": "Objets",
        "Total labeling": "Étiquetages totales",
        "Total scenes": "Scènes totales",
        "Workers": "Travailleurs",
        "Sample": "Échantillon",
        "import": "Importer",
        "Show 10": "Afficher 10",
        "Scene for classifications are not available": "Les scènes ne sont pas disponible pour des projets de type classification",
        "No scene avilable": "Aucune scène disponible",
        "Grid": "Grille",
        "Delete this project": "Supprimer ce projet",
        "Deleting a project will also delete all the labellings and scenes that have been submitted to a project.": "La suppression d'un projet supprimera également toutes les étiquettes et scènes qui ont été soumises.",
        "Delete project": "Supprimer le projet",
        "Transfer Project to another company": "Transférer le projet vers un autre espace de travail",
        "Transfer project": "Projet de transfert",
        "Select company": "Sélectionner l'espace de travail",
        "Project moved to": "Projet déplacé vers",
        "Change sample": "Changer d'échantillon",
        "Please upload image!": "Veuillez télécharger l'image !",
        "Instruction": "Instruction",
        "Total labelling": "Étiquetage total",
        "Scene(s)": "Scène(s)",
        "Scene": "Scène",
        "Project(s)": "Projet(s)",
        "Heatmaps are not available for Classification": "Les cartes thermiques ne sont pas disponibles pour la classification",
        "Page not have heatmaps": "La page n a pas de cartes thermiques",
        "Test": "Test",
        "Train": "Entrainer",
        "Object Distribution": "Distribution d'objets",
        "Image Size Distribution": "Répartition de la taille des images",
        "Annotations Per Image": "Annotations par image",
        "Page not have analytics": "La page n'a pas d'analyse",
        "Update Dataset": "Mettre à jour le jeux de données",
        "Transfer Dataset": "Transférer le jeux de données",
        "error in update dataset": "erreur dans la mise à jour du jeu de données",
        "dataset updated successfully": "jeu de données mis à jour avec succès",
        "Dataset moved to": "Jeu de données déplacé vers",
        "Export results": "Exporter les résultats",
        "Sorry, not able to export your documents. Please try again later or contact support.": "Désolé, impossible d exporter vos documents. Veuillez réessayer ultérieurement ou contacter l assistance.",
        "Documents exported successfully": "Documents exportés avec succès",
        "Change": "Changer",
        "Select state": "Sélectionner l'état",
        "Select catagory": "Choisir une catégorie",
        "category change sucessfully!": "changement de catégorie réussi !",
        "company change sucessfully!": "changement de dossier réussi !",
        "state change sucessfully!": "changement d'état réussi !",
        "status change sucessfully!": "changement de statut réussi !",
        "This request is under processing. Please wait when is processed 📝": "Cette demande est en cours de traitement. Veuillez patienter pendant le traitement 📝",
        "Oops, this request is not compatible with new version. Please try to submit new request or contact support. 🗒": "Oups, cet traitement n est pas compatible avec la nouvelle version. Veuillez essayer de soumettre une nouvelle demande ou contacter le support. 🗒",
        "1. Request information": "1. Détail du traitement",
        "Path:": "Chemin API:",
        "Number:": "Numéro:",
        "Request ID:": "Identifiant du traitement :",
        "Task ID:": "ID de la tâche serveur :",
        "Account name:": "Nom du compte:",
        "State:": "État:",
        "Status:": "Statut:",
        "Category:": "Catégorie:",
        "Company": "Entreprise",
        "Total documents:": "Nombre de documents :",
        "Total pages:": "Nombre de pages :",
        "Created at:": "Date de création:",
        "Started at:": "Début du traitement:",
        "Processed at:": "Fin du traitement:",
        "Time processing:": "Temps de traitement :",
        "Tags:": "Balises:",
        "Author:": "Auteur:",
        "2. Document List": "2. Liste des documents",
        "Document": "Document",
        "Pages": "Pages",
        "Extension": "Extension",
        "+ Add Rows": "+ Ajouter une ligne",
        "Loading comments": "Chargement des commentaires",
        "Edit": "Modifier",
        "+ Add class": "+ Ajouter une classe",
        "+ Add entity": "+ Ajouter un champ",
        "Add row": "Ajouter une rangée",
        "Update row": "Mettre à jour la ligne",
        "Update class": "Mettre à jour la classe",
        "Add class": "Ajouter une classe",
        "Document name": "Nom du document",
        "Add entity": "Ajouter un champ",
        "New entity": "Nouveau champ",
        "Update entity": "Mettre à jour le champ",
        "Second value": "Deuxième valeur",
        "Value": "Valeur",
        "Select page": "Sélectionner une page",
        "Select Class": "Sélectionner une classe",
        "value2": "valeur2",
        "value": "valeur",
        "Select entity": "Sélectionner un champ",
        "Exports(s)": "Exportations",
        "Request(s)": "Traitement(s)",
        "change state": "changer d'état",
        "change category": "changer de catégorie",
        "Change state": "Modifier l'état",
        "Change category": "Modifier la catégorie",
        "company": "Dossier",
        "Change company": "Transférer vers un autre dossier",
        "Export result": "Exporter les résultats",
        "Low confidence": "Confiance faible",
        "Active learning": "Apprentissage actif",
        "All": "Tous",
        "1 day": "Un jour",
        "1 week": "1 semaine",
        "1 month": "1 mois",
        "3 months": "3 mois",
        "Submit a request": "WikiBox",
        "You can organize your work by status and categories.": "Vous pouvez organiser votre travail par statut et par catégorie.",
        "Add category or status": "Ajouter une catégorie ou un statut",
        "See all categories": "Voir toutes les catégories",
        "Categories": "Catégories",
        "See all status": "Voir tous les statuts",
        "Status": "Statut",
        "Step 1. Documents": "Étape 1. Documents",
        "Documents": "Documents",
        "Import your documents for processing by Wikibank Platform.": "Importer vos documents pour un traitement par l'IA.",
        "Step 2. Path": "Étape 2. API",
        "API": "API",
        "Configure your API.": "Commencer par sélectionner une API, une catégorie ainsi qu'un type de format de sortie de données pour démarrer votre traitement.",
        " Step 3. Tags": " Étape 3. Balises",
        "Step 4. Preview": "Étape 4. Aperçu",
        "Statuses": "Statuts",
        "3.tags": "3. Balises",
        "🤖 Tags can help AI to understand better your documents": "🤖 Les balises peuvent aider l'IA à mieux comprendre vos documents pendant la phase de traitement.",
        "Preview your import details before processing.": "Prévisualisez votre configuration avant le traitement par l'IA.",
        "Receive notification email": "Recevoir une notification par e-mail",
        "Select an export type": "Sélectionner un format de sortie",
        "List export types": "Répertorier les types d'exportation",
        "List catagory": "Catégorie de liste",
        "Select a category": "Choisir une catégorie",
        "Category": "Catégorie",
        "List of APIs available on marketplace pre-trained": "Liste des APIs disponibles sur IA Marketplace et vos APIs personnalisées",
        "API Pretained model": "Modèle conservé par l'API",
        "Select an API": "Sélectionner une API",
        "Wikibank currently supports PNG, JPEG, and PDF formats.": "Wikibank prend actuellement en charge les formats PNG, JPEG et PDF.",
        "Image files sent to the Wikibank API should not exceed 100 MB (4 MB for the free tier).": " Les fichiers images envoyés à l'API Wikibank ne doivent pas dépasser 100 Mo (4 Mo pour le niveau gratuit).",
        "Reducing your file size can significantly improve throughput; however, be careful not to reduce image quality in process": " La réduction de la taille de votre fichier peut améliorer considérablement le débit ; cependant, veillez à ne pas réduire la qualité de l'image pour un traitement optimal",
        "Upload a document(s)": "Télécharger un ou plusieurs documents",
        "Dashboard": "Tableau de bord",
        "Synthese": "Synthèse",
        "Sorry, not able to submit document. Please try again later or contact support.": "Désolé, impossible de soumettre le document. Veuillez réessayer ultérieurement ou contacter l assistance.",
        "Document submitted successfully": "Document envoyé avec succès",
        "Path is required field": "Le chemin est un champ obligatoire",
        "This request is archived because over 2 weeks of retention data.": "Ce traitement a été supprimé car il dépassait la rétention de données maximale autorisée.",
        "Detail": "Détail",
        "1 hour": "1 heure",
        "Nothing": "Aucune",
        "Deleted": "Supprimé",
        "Dataset(s)": "Jeux de données",
        "You need contact Wikibank Team for upload datasets": "Vous devez contacter l'équipe Wikibank pour télécharger des ensembles de données",
        "You need contact Wikibank Team for generate datasets": "Vous devez contacter l'équipe Wikibank pour générer des jeux de données",
        "Dataset generated successfully!": "Jeu de données généré avec succès !",
        "Documentation": "Documentation",
        "Developer Guide": "Guide du développeur",
        "API Reference": "Référence API",
        "Admin": "Administration",
        "Terms of use": "Conditions d'utilisation",
        "Legal notice": "Mention légale",
        "GDPR": "RGPD",
        "Privacy policy": "Politique de confidentialité",
        "© 2016-2023, Wikibank Platform, All rights reserved.": "© 2016-2023, Plateforme Wikibank, Tous droits réservés.",
        "View analytics for your requests": "Analyser les demandes de vos APIs",
        "Create API for make visible your models.": "Gérer vos APIs pour rendre visible vos modèles",
        "Test your model and inference.": "Appliquer des tests de vos modèles",
        "Train the model with your data.": "Entraîner vos modèles IA avec vos jeux de données",
        "Generate a dataset zip file for training.": "Générer des fichiers zip pour l'entrainement de vos modèles",
        "Collect, prepare and clean out your data.": "Collecter, préparer et nettoyer vos données brutes",
        "Generate your synthetic data and label your real data.": "Créer des projets avec vos données synthétiques ou étiqueter vos images",
        "View your inference API and deploy the model.": "Aperçu de votre API et déployer vos modèles",
        "Step 10. Preview": "Étape 10. Aperçu",
        "Press": "Presser",
        "ENTER": "ENTRER",
        "for add new tag": "pour ajouter une nouvelle balise",
        "ESC": "ESC",
        "to cancel": "pour annuler",
        "Create a tag for your inference.": "Créer une balise pour votre API.",
        "Step 9. Tags": "Étape 9. Balises",
        "Tables": "Tables",
        "Export": "Exporter",
        "category": "Categorie",
        "state": "État",
        "status": "Statut",
        "Change Stats": "Modifier l'état",
        "Change Status": "Modifier le statut",
        "Change Category": "Modifier la catégorie",
        "Dashboard configuration.": "Moduler l'affichage et les actions sur le tableau de bord pour cette API",
        "Change edit document status, state": "Modifier les états du document",
        "Allow items :": "Actions à autoriser :",
        "Confidence": "Confiance du modèle",
        "Entity Name": "Nom de l'entité",
        "Display items :": "Éléments à afficher :",
        "We recommend that you do not use a large machine if you plan to deploy gnn or python inference task. 😃": "Nous vous recommandons de ne pas utiliser une grande machine si vous envisagez de déployer une API avec une architecture GNN ou python. 😃",
        "Dashboard configuration": "Configuration du tableau de bord",
        "Step 8. Dashboard configuration": "Étape 8. Configuration du tableau de bord",
        "It's not possible to update this information during inference processing ": "Il n'est pas possible de mettre à jour ces informations pendant le traitement de l'inférence ",
        "- Machine 6 GiB memory size for GNN inference or python task": "- Taille de la mémoire de la machine 6 GiB pour l'inférence GNN ou la tâche python",
        "- Machine 10 GiB memory size for computer vision task": "- Taille de la mémoire de la machine 10 Gio pour la tâche de vision par ordinateur",
        "- Machine 16 GiB memory size for big or complex model (complex or multiple models etc...)": "- Taille de la mémoire de la machine 16 Gio pour les modèles volumineux ou complexes (modèles complexes ou multiples, etc.)",
        "Machine capacity for your inference.": "Capacité de la machine pour votre inférence.",
        "Server execution time for inference processing.": "Temps d'exécution du serveur pour le traitement des inférences.",
        "All inferences running on CPU device": "Toutes les inférences s'exécutant sur un périphérique CPU",
        "Step 7. Capacity management": "Étape 7. Gestion de la capacité",
        "Manage capacity of machine for your inference": "Gérer la capacité de la machine pour votre API",
        "Testing": "Test",
        "Step 6. Testing": "Étape 6. Test",
        "Test your inference before deploying it.": "Tester votre API avant de la déployer.",
        "Select Queue name": "Sélectionner le nom de la file d'attente",
        "Purge response": "Purger la réponse API",
        "Disable saved documents name": "Désactiver le nom des documents enregistrés en base de données",
        "Queue name": "Nom de la file d'attente",
        "Retension": "Rétention des données",
        "Security": "Sécurité",
        "Show more...": "Voir plus...",
        "Show less": "Voir moins",
        "Step 5. Security": "Étape 5. Sécurité",
        "Specify important security actions to protect your data": "Spécifier les actions de sécurité importantes pour protéger vos données",
        "Post-processing": "Post-traitement",
        "Step 4. Post-processing": "Étape 4. Post-traitement",
        "Apply clean build-in functions to post-process your model.": "Appliquer des fonctions intégrées pour post-traiter vos modèles IA.",
        "Keep entities from projects": "Rajouter une liste d'entities à partir de vos projets",
        "keep_best_class": "keep_best_class",
        "Keep best class filtered by confidence value.": "Gardez la meilleure classes filtrée par valeur de confiance.",
        "group_entity_by_name": "group_entity_by_name",
        "Group bounding box and fixed issues value splited.": "Zone de délimitation du groupe et valeur des problèmes résolus divisée.",
        "group_horizontal_entity_by_name": "group_horizontal_entity_by_name",
        "Group horizontal bounding box and fixed issues value splited.": "Zone de délimitation horizontale du groupe et valeur des problèmes résolus divisée.",
        "keep_best_entity": "keep_best_entity",
        "Keep best entities filtered by confidence value.": "Conserver les meilleures entités filtrées par valeur de confiance.",
        "remove_low_confidence": "remove_low_confidence",
        "Remove low confidence and keep only good element.": "Supprimer la faible confiance et ne conservez que les bons éléments.",
        "rename": "Renommer",
        "Rename entities and class name.": "Renommer les entités et le nom de la classes.",
        "add_type_list": "add_type_list",
        "Type entites object for user experience.": "Tapez l objet Entites pour l expérience utilisateur.",
        "text_cleaning": "text_cleaning",
        "Remove specials charaters and keep alphanumeric.": "Supprimer les caractères spéciaux et conservez l alphanumérique.",
        "replace_colors": "replace_colors",
        "Change color field on entity and class object.": "Modifier le champ de couleur sur l entité et l objet de classes.",
        "Add model": "Ajouter un modèle",
        "Select Train": "Sélectionner train",
        "Models": "Modèles",
        "Step 3. Models": "Étape 3. Modèle",
        "Attach different models to your API.": "Attacher différents modèles à votre API.",
        "Attach different models to your test.": "Attacher différents modèles à votre test.",
        "Path (URL)": "Chemin (URL)",
        "Configurate your API route.": "Configurer une URL complête pour votre API.",
        "Pretrained": "Préformé",
        "Beta": "Bêta",
        "Flow": "Processus",
        "Default image": "Image par défaut",
        "Select language": "Choisir la langue",
        "Language": "Langue",
        "Select Country": "Choisissez le pays",
        "Country": "Pays",
        "Select Category": "Choisir une catégorie",
        "Category": "Catégorie",
        "Display Name": "Nom d'affichage",
        "*Adding an inference name is a required field.": "*Le nom de l'API est obligatoire.",
        "Name and describe your inference.": "Nommer et décriver  votre API.",
        "Add Fields": "Ajouter des champs",
        "Add fields from project": "Ajouter des champs à partir du projet",
        "All input fields need to field": "Tous les champs de saisie doivent être remplis",
        "Path you entered already exist, please try with another one.": "Le chemin que vous avez entré existe déjà, veuillez essayer avec un autre.",
        "*Each tag consists of a value. You can use tags to search and filter your resources.": "*Chaque balise est constituée d'une valeur. Vous pouvez utiliser des balises pour rechercher et filtrer vos ressources.",
        "Test your inference before deploy.": "Testez votre inférence avant le déploiement.",
        "Environnements variables": "Variables d'environnement",
        "Describe YML configuration to your inference": "Décriver une configuration YML pour votre API",
        "Step 4. Environnements variables": "Étape 4. Variables d'environnements",
        "Pass Splitting": "Passer le fractionnement des PDFs",
        "Funtion name": "Nom de la fonction",
        "Function": "Fonction",
        "Step 3. Function": "Étape 3. Fonction",
        "Specify a post-processing function.": "Spécifier une fonction de post-traitement.",
        "Name required": "Nom (obligatoire",
        "Server execution time for your inference processing.": "Temps d'exécution du serveur pour votre traitement d'inférence.",
        "- Machine 8 GiB memory size for big or complex model (like complex or multiple models etc...)": "- Taille de la mémoire de la machine 8 GiB pour les modèles volumineux ou complexes (comme les modèles complexes ou multiples, etc.)",
        "- Machine 6 GiB memory size for computer vision task": "- Taille de la mémoire de la machine 6 Gio pour la tâche de vision par ordinateur",
        " - Machine 4 GiB memory size for GNN inference or python task": " - Taille de la mémoire de la machine 4 GiB pour l'inférence GNN ou la tâche python",
        "💡 We recommend that you do use a small machine if you plan to deploy GNN or python inference task. 😃": "💡 Nous vous recommandons d'utiliser une petite machine si vous envisagez de déployer une tâche d'inférence GNN ou python. 😃",
        "Restore": "Restaurer",
        "Revision restored sucessfully!": "Révision restaurée avec succès !",
        "an error has occured, Please try again or contact wikibank": "une erreur s est produite, veuillez réessayer ou contacter wikibank",
        "Delete this inference": "Supprimer cette inférence",
        "Update inference": "Mettre à jour l'inférence",
        "Delete inference": "Supprimer l'inférence",
        "Tag": "Étiqueter",
        "Change default image": "Modifier l image par défaut",
        "Inference updated successfully": "Inférence mise à jour avec succès",
        "error in update Model": "erreur dans la mise à jour du modèle",
        "API(s)": "API(s)",
        "Roll Back inference": "Revenir en arrière",
        "Roll back version": "Annuler la version",
        "Device Disk": "Disque de périphérique",
        "Device Memory": "Mémoire de l'appareil",
        "Device CPU": "Unité centrale de l'appareil",
        "12 hours": "12 heures",
        "3 days": "3 jours",
        "Last year": "L'année dernière",
        "CPU": "CPU",
        "Memory": "Mémoire",
        "Disk": "Disque",
        "GPU": "GPU",
        "1. description": "1. descriptif",
        "Logs": "Journaux",
        "Author": "Auteur",
        "Date created": "Date de création",
        "3.tags": "3. Balises",
        "List": "Liste",
        "2. Documents": "2. Documents",
        "Email notification": "Notification email",
        "Document list": "Liste des documents",
        "category": "Catégorie",
        "Developers": "Développeurs",
        "1. Informations": "1. Informations",
        "It may take from 2 to 15 minutes for generate zip dataset": "L'allocation d'une machine peut prendre environ 2 à 10 minutes pour démarrer",
        "1. details": "1. détails",
        "Item": "Article",
        "OCR Processing": "Traitement OCR",
        "Machine Capicity": "Capacité de la machine",
        "2. Description": "2. Descriptif",
        "4. Labelling data": "4. Données d'étiquetage",
        "Test rate": "Taux de test",
        "Filter": "Filtre",
        "Projects labeling": "Labellisation des projets",
        "5. Synthetic data": "5. Données synthétiques",
        "3. standardisation ": "3. normalisation",
        "No": "Non.",
        "New key": "Nouvelle clé",
        "3. Train dataset": "3. Entraîner un jeu de données",
        "Project": "Projet",
        "Size": "Taille",
        "Generation": "Génération",
        "Labelling": "Étiquetage",
        "4. Test dataset": "4. Ensemble de données de test",
        "Task type": "Type de tâche",
        "State": "État",
        "Dataset URL": "URL du jeu de données",
        "filtered Dataset": "Jeu de données filtré",
        "Annotated images": "Images annotées",
        "Annotated and validated images": "Images annotées et validées",
        "Annotated without unvalidated images": "Annoté sans images non validées",
        "Labeling project(s)": "Projet(s) de labellisation",
        "Knowledge Vision models": "Modèles de vision des connaissances",
        "Total checkpoints": "Points de contrôle",
        "Label(s)": "Étiquetage(s)",
        "Labelings": "Étiquetages",
        "Created at": "Date de création",
        "Train dataset": "Ensemble de données de train",
        "Test dataset": "Ensemble de données de test",
        "Function Name": "Nom de la fonction",
        "Version": "Version",
        "2. models": "2. Modèles",
        "Dashboard Configuration": "Configuration du tableau de bord",
        "Display Items": "Affichage",
        "Disable saving documents name": "Désactiver l'enregistrement du nom des documents",
        "Delete file after processing": "Supprimer les documents après traitement",
        "Disable saving response result": "Désactiver l'enregistrement du résultat de la réponse",
        "Datasets": "Jeux de données",
        "threshold": "seuil d'acceptance",
        "Project Labeling": "Projets d'étiquetage",
        "models": "des modèles",
        "Template": "Examples",
        "Configuration (Expert mode)": "Configuration (mode expert)",
        "configuration (Basic mode)": "configuration (mode de base)",
        "Batch": "Lot",
        "Epoch": "Époque",
        "Learning Rate": "Taux d'apprentissage",
        "Checkpoints": "Points de contrôle",
        "Simple-mode Details": "Détails du mode simple",
        "inference": "inférence",
        "Labelling project(s)": "Projet(s) de labellisation",
        "Copy Configuration": "Copier la configuration",
        "Download the configuration file": "Télécharger le fichier de configuration",
        "Configuration file": "Fichier de configuration",
        "Members": "Membres",
        "color": "Couleur",
        "Next: Documents": "Étape suivante: Documents",
        "Next: Tags": "Étape suivante: Tags",
        "Next: Preview": "Étape suivante: Aperçu",
        "export Type": "type d'exportation",
        "Steps items": "Éléments d'étapes",
        "Step 3. Preview": "Étape 3. Aperçu",
        "Preview all the details before creating your company": "Prévisualisez tous les détails avant de créer votre espace de travail",
        "Specify categories and status": "Spécifiez les catégories et le statut",
        "Step 3. Dashboard": "Étape 3. Tableau de bord",
        "Add members to company.": "Ajouter des membres à votre espace de travail.",
        "Step 2. Members": "Étape 2. Membres",
        "Name, describe and choose the symbol for company": "Nommer, décriver et choisisser une vignette pour votre nouvelle espace de travail",
        "Add export type": "Ajouter un type d'exportation",
        "Output type": "Format de sortie",
        "Enter a name": "Entrer un nom",
        "Enter a description": "Entrer une description",
        "Enter a task": "Entrer un nom pour votre tâche",
        "Comment Activate": "Activer la gestion des commentaires",
        "Export type": "Type d'exportation",
        "receiveslacknotif": "Ajouter un lien webhook Slack pour recevoir une notification sur un #channel après la fin de chaque traitement de données",
        "Slack notification link": "Lien webhook de notification Slack",
        "Add Category": "Ajouter une catégorie",
        "Organiser vos traitements par status afin de créer plus de profondeur dans l'analyse de vos données.": "Organiser vos traitements par status afin de créer plus de profondeur dans l'analyse de vos données.",
        "Exemple de status: En cours, À corriger, Dossier incomplet, Approuvé": "Exemple de status: En cours, À corriger, Dossier incomplet, Approuvé",

        "Attacher une API et un type d'export de données par défaut sur cet espace de travail.": "Attacher une API et un type d'export de données par défaut sur cet espace de travail.",
        "Organiser vos traitements par status afin suivre dans le temps évolution de vos données.": "Organiser vos traitements par status afin suivre dans le temps évolution de vos données.",
        "Organiser vos traitements par catégorie afin de créer des segments dans l'analyse de vos données.": "Organiser vos traitements par catégorie afin de créer des segments dans l'analyse de vos données.",
        "Les priorités permettent de saisir les dossiers ou traitements les plus urgents à faire en premier.": "Les priorités permettent de saisir les dossiers ou traitements les plus urgents à faire en premier.",
        "Ajouter des points de contrôle dans vos traitements afin de ne rien oublier dans l'analyse de vos dossiers sur les éléments importants.": "Ajouter des points de contrôle dans vos traitements afin de ne rien oublier dans l'analyse de vos dossiers sur les éléments importants.",
        "Ajouter l'option commentaire dans vos traitements afin communiquer avec vos clients, votre team en interne ou avec Wikibank!": "Ajouter l'option commentaire dans vos traitements afin communiquer avec vos clients, votre team en interne ou avec Wikibank!",
        "Configurer un email entrant afin de recevoir des traitements sur cet espace de travail directement depuis votre boîte de réception Gmail ou Outlook.": "Configurer un email entrant afin de recevoir des traitements sur cet espace de travail directement depuis votre boîte de réception Gmail ou Outlook.",
        "Définir une durée de retention des données selon votre organisation.": "Définir une durée de retention des données selon votre organisation.",
        "Exemple de catégorie: Produit 1, Catalogue 1, 2 ou Type 1 et 2": "Exemple de catégorie: Produit 1, Catalogue 1, 2 ou Type 1 et 2",
        "Priority": "Priorité",
        "Add Status": "Ajouter un statut",
        "Select user": "Sélectionner l'utilisateur",
        "Data store": "Magasin de données",
        "Analytics": "Analytique",
        "Upload the image in JPG or PNG format": "Télécharger une image au format JPG ou PNG",
        "Logo": "Logo",
        "No status available": "Aucun statut disponible",
        "No category available": "Aucune catégorie disponible",
        "No priority available": "Aucune priorité disponible",
        "Enter your task": "Entrez votre tâche",
        "Enter your Description": "Entrez votre descriptif",
        "Please select color for your company": "Veuillez sélectionner une couleur pour votre espace de travail",
        "Please upload image for your company!": "Veuillez télécharger une image pour votre espace de travail !",
        "Please add task name!": "Veuillez ajouter un nom de tâche !",
        "Please add description!": "Veuillez ajouter une description !",
        "Retension Data": "Retention des données",
        "Update company": "Mettre à jour l'espace de travail",
        "Send your documents from email inbox for appling documents processing directly without leave your inbox": "Envoyer vos documents à partir d'un email pour appliquer des traitements sans quitter votre boîte de réception",
        "List of people can send email on this dashboard": "Liste des personnes pouvant envoyer des e-mails sur ce tableau de bord",
        "Email inbound": "E-mail entrant",
        "Inbound email Configuration": "Configuration des e-mails entrants",
        "API Configuration": "Configuration de l'API",
        "Select a user": "Sélectionner un utilisateur",
        "Task *": "Tâche *",
        "Description *": "Description *",
        "Name *": "Nom *",
        "Add members!": "Ajouter des membres !",
        "Select image or color!": "Sélectionner l'image ou la couleur !",
        "My custom models": "Mon API personnalisée",
        "Ask for train my custom models x10 faster with Wikibank Platform": "Demander à former mes modèles IA personnalisés x10 plus rapidement avec la plateforme Wikibank",
        "AI Marketplace": "IA Marketplace",
        "Discover all pre-trained models available on Wikibank Platform": "Tester nos modèles IA pré-entraînés en ligne depuis l'interface Wikibank",
        "members": "membres",
        "Date": "Date",
        "Create new company for organize your better workflow": "Créer un nouvel espace de travail pour organiser votre flux",
        "Create new company": "Créer un nouvel espace de travail",
        "Hello 👋, you are not currently in any company. Ask your administrator to add you to a company to start your experience with Wikibank Platform 🚀": "Bonjour 👋, vous n'êtes actuellement dans aucun espace de travail. Demandez à votre administrateur de vous ajouter à un espace de travail pour commencer votre expérience avec Wikibank Platform 🚀",
        "Your account was suspended because of unpaid suscription. After payment, your account will be restored.": "Votre compte a été suspendu en raison d'un abonnement non payé. Après paiement, votre compte sera restauré.",
        "Your account is expired, please contact sales team for review your account.": "Votre compte a expiré, veuillez contacter l'équipe commerciale pour examiner votre compte.",
        "Your account expire soon in": "Votre compte expire bientôt dans",
        "days, please contact sales team for review your account. 🚀": "jours, veuillez contacter l'équipe commerciale pour examiner votre compte. 🚀",
        "Welcome to the Wikibank platform, your account must be verified by the sales team and we will contact you for more details.": "Pour poursuivre votre intégration, notre équipe support vous contactera afin d'en savoir plus sur vos besoins et vous donnez accès aux modules dont vous avez besoin.",
        "Welcome to Wikibank Platform 🚀🚀": "Bienvenue sur la plateforme Wikibank 🚀🚀",
        "Organise your workflow in one single place.": "Organiser votre flux de travail en différents espaces.",
        "Company deleted!": "Espace de travail supprimé !",
        "Send": "Envoyer",
        "Model(s)": "Modèle(s)",
        "You need contact Wikibank Team for train models": "Vous devez contacter l'équipe Wikibank pour les modèles de train",
        "Resume": "Reprendre",
        "putNewPasswordBegin":"Saisissez votre mot de passe",
        "Select checkpoints": "Sélectionner les points de contrôle",
        "putNewPasswordBegin":"Saisissez votre mot de passe",
        "Resume train": "Reprendre le train",
        "Metrics not available": "Métriques non disponibles",
        "The checkpoint(s)": "Les points de contrôle",
        "should be the best": "devraient être les meilleurs",
        "Chart": "Graphique",
        "Table": "Table de comparaison",
        "Val": "Val",
        "Max": "Max",
        "Min": "Min",
        "Skip": "Ignorer",
        "Rename": "Renomer",
        "Evaluation": "Évaluation",
        "Download model": "Télécharger le modèle",
        "checkpoint(s)": "points de contrôle",
        "Download checkpoint": "Télécharger le point de contrôle",
        "See advanced configuration": "Voir la configuration avancée",
        "Configuration content": "Contenu de configuration",
        "Page not have logs": "Aucun journal disponible",
        "True label": "Véritable étiquette",
        "Predicted label": "Libellé prédit",
        "Confusion matrix not available": "Matrice de confusion non disponible",
        "Absolute matrix": "Matrice absolue",
        "Relative matrix": "Matrice relative",
        "Disk Device": "Périphérique de disque",
        "CPU Device": "Périphérique CPU",
        "Device": "Appareil",
        "You should select small machine or increase your batch size for next similar training": "Vous devez sélectionner une petite machine ou augmenter la taille de votre lot pour la prochaine formation similaire",
        "Update model": "Mettre à jour le modèle",
        "Company": "Espace de travail",
        "Transfer Train": "Train de transfert",
        "Train updated successfully": "Train mis à jour avec succès",
        "Train moved to": "Train déplacé vers",
        "Account(s)": "Comptes)",
        "Loading inference account(s)": "Chargement des comptes APIs",
        "Metadata": "Métadonnées",
        "Time processing": "Temps de traitement",
        "Processed at": "traité à",
        "Started at": "Commencé à",
        "Total documents": "Documents totaux",
        "Account name": "Nom du compte",
        "Task ID": "ID de tâche",
        "Stats": "Etat",
        "Request ID": "Identifiant du traitement",
        "Request information": "Informations requises",
        "Extract french Liasse fiscale entites from documents 2033, 2050 2035": "Extrait Liasse fiscale entités des documents 2033, 2050 2035",
        "Train your model with your data (either personal or generated by datalabs) and visualize the result": "Entraîner votre modèle avec vos données (personnelles ou générées par des datalabs) et visualisez le résultat",
        "Analyze your inference request on production": "Analyser votre demande d'inférence sur la production",
        "Use our models for data detection, extraction, analysis and classification.": "Utiliser nos modèles pour la détection, l extraction, l analyse et la classification des données.",
        "see more": "Voir plus",
        "Project Labelling": "Étiquetage du projet",
        "View your testing API and deploy the model.": "Vérifier votre configuration de test et lancer.",
        "Create a tag for your testing.": "Créer des balises pour vos tests.",
        "Step 8. Tags": "Étape 8. Balises",
        "Launch test": "Lancer le test",
        "Machine capacity for your testing.": "Capacité de la machine pour vos tests.",
        "Server execution time for testing processing.": "Temps d'exécution du serveur pour tester le traitement.",
        "Manage capacity of machine for your testing": "Gérer la capacité de la machine pour vos tests",
        "Threshold must be between 0 to 100 ": "Le seuil d'acceptance doit être compris entre 0 et 100 ",
        "limitation must be between 0 to 100000 ": "la limite doit être comprise entre 0 et 100000 ",
        "Step 2. Configuration": "Étape 2. Configuration",
        "Configurate task type for testing model.": "Configurer le type de tâche pour tester le modèle.",
        "Threshold": "Seuil d'acceptance",
        "Name and describe your testing.": "Nommer et décriver votre test.",
        "No Results were found": "Aucun resultat n a été trouvé",
        "ClassList": "ListeClasse",
        "OriginalImage": "Image originale",
        "Url": "URL",
        "Testing(s)": "Test(s)",
        "Delete Testing": "Supprimer le test",
        "Update Testing": "Mettre à jour",
        "Delete this testing": "Supprimer ce test",
        "testing updated successfully": "test mis à jour avec succès",
        "Category(s)": "Catégorie(s)",
        "category not found.": "catégorie introuvable.",
        "Auto labelling is disable because it's already in progress.": "L'étiquetage automatique est désactivé car il est déjà en cours.",
        "Start auto-labelling": "Démarrer l'étiquetage automatique",
        "Add limit": "Ajouter une limite",
        "Limit": "Limite",
        "Add threshold": "Ajouter un seuil d'acceptance",
        "Auto Labelling": "Étiquetage automatique",
        "Train Epoch": "Époque du train",
        "Auto labelling submitted sucessfully.": "Étiquetage automatique soumis avec succès.",
        "Search by account name": "Rechercher par nom de compte",
        "Search by status": "Rechercher par statut",
        "Search by category": "Rechercher par catégorie",
        "Search by path": "Rechercher par chemin",
        "Font size": "Taille",
        "Please select font family": "Veuillez sélectionner la famille de police",
        "Font family": "Famille",
        "Text align": "Alignement",
        "Font weight": "Poids",
        "Background Color": "Couleur de l arrière plan",
        "+ Add source": "+ Ajouter une source",
        "Please select preset": "Veuillez sélectionner le magasin de données",
        "Source(s)": "Source(s)",
        "H max": "H max",
        "H min": "H min",
        "W max": "W max",
        "W min": "W min",
        "Y min": "Y min",
        "X min": "X min",
        "Position": "Position",
        "Text": "Texte",
        "Please select project and scenes": "Veuillez sélectionner le projet et les scènes",
        "Source": "La source",
        "Font": "Police de caractère",
        "No data avialable": "Aucune donnée disponible",
        "Class Name": "Nom de classe",
        "Best class": "Meilleures classes",
        "SearchNumber": "NuméroRecherche",
        "Search": "Recherche",
        "Credit": "Crédit",
        "Debit": "Débit",
        "Label": "Étiqueter",
        "Alerts": "Alertes",
        "Not Verified": "Non vérifiée",
        "Verified": "Vérifiée",
        "Alerts": "Alertes",
        "Mark as see": "Marquer comme vu",
        "To review": "A revérifier",
        "See on document": "Voir sur le document",
        "Best entities": "Meilleurs champs",
        "No Document were found related to this request": "Aucun document n'a été trouvé lié à ce traitement",
        "Upload a document": "Télécharger un document",
        "Select by user": "Sélection par utilisateur",
        "Select by time": "Sélection par heure",
        "Select by status": "Sélection par statut",
        "The analytics page shows the number of the labelled images and the number of hours spent on the process": "La page d'analyse indique le nombre d'images étiquetées et le nombre d'heures consacrées au processus",
        "Show additional Comments": "Afficher les commentaires supplémentaires",
        "Comments": "Commentaires",
        "Save": "Sauvegarder",
        "Enter name": "Entrez le nom",
        "Enter description": "Entrer une description",
        "Settings saved successfully!": "Paramètres enregistrés avec succès !",
        "Disapprove label": "Refuser le libellé",
        "Approve label": "Approuver le libellé",
        "Unskip label": "Ne pas ignorer l'étiquette",
        "Skip label": "Ignorer l'étiquette",
        "Jump to next page": "Passer à la page suivante",
        "Jump to previous page": "Aller à la page précédente",
        "Jump to next item": "Passer à l'élément suivant",
        "Jump to previous item": "Aller à l'élément précédent",
        "Previous step": "Étape précédente",
        "Next step": "Étape suivante",
        "Loading configuration": "Nous récupérons votre configuration 💪",
        "GENERAL": "GÉNÉRALE",
        "VIEW CONTROLS": "VOIR LES COMMANDES",
        "Zoom in": "Agrandir",
        "Zoom out": "Dézoomer",
        "or": "ou alors",
        "Paste": "Coller",
        "Duplicate": "Dupliquer",
        "Delete objects": "Supprimer des objets",
        "OBJECTS": "OBJETS",
        "TOOLS": "OUTILS",
        "Your account will be logout in": "Votre compte sera déconnecté dans",
        "Warning": "Avertissement",
        "Forgot password?": "Mot de passe oublié?",
        "Don't have an account?": "Vous n'avez pas de compte ?",
        "© Copyright ": "© Droit d'auteur ",
        "Sign in with Microsoft": "Connectez-vous avec Microsoft",
        "Sign in with Google": "Connectez-vous avec Google",
        "to securely access your account with a new password.": "pour accéder en toute sécurité à votre compte avec un nouveau mot de passe.",
        "If you like to sign in with this email, please use": "Si vous souhaitez vous connecter avec cet e-mail, veuillez utiliser",
        "Forgot password": "Mot de passe oublié",
        "Looks like you already have registered with Google account. Please use": "Il semble que vous soyez déjà enregistré avec un compte Google. Veuillez utiliser",
        "Withdraw the recovery link": "Retirer le lien de récupération",
        "We will email you a recovery link": "Nous vous enverrons un lien de récupération par e-mail",
        "Cannot connect?": "Impossible de se connecter?",
        "Plateforme Cloud d automatisation": "Plateforme Cloud d automatisation",
        "Sorry, the maximum is 5 keys.": "Désolé, le maximum est de 5 clés.",
        "Password successfull changed.": "Mot de passe modifié avec succès.",
        "New password and confirm new password not matching.": "Nouveau mot de passe et confirmation que le nouveau mot de passe ne correspond pas.",
        "Old password is incorrect.": "Ancien mot de passe est incorrect.",
        "Password not changed, please try later or contact support.": "Le mot de passe n a pas changé, veuillez réessayer plus tard ou contacter le support.",
        "Show": "Afficher",
        "Next": "Suivant",
        "Add document": "Ajouter un document",
        "Merge document": "Fusionner avec un autre traitement",
        "Load more requests": "Charger plus de traitements",
        "Require password change at next login": "Exiger le changement de mot de passe à la prochaine connexion",
        "Automatically generate password": "Générer automatiquement un mot de passe",
        "Reset password for user": "Réinitialiser le mot de passe pour l'utilisateur",
        "Password edited!": "Mot de passe modifié !",
        "Pretranied": "Prétranié",
        "Please enter a valid email": "Veuillez entrer un email valide",
        "Email": "E-mail",
        "Add": "Ajouter",
        "Last name": "Nom de famille",
        "user(s)": "utilisateur(s)       ",
        "Drop your files here": "Déposez vos fichiers ici",
        "In demo live, we will analyze only the": "En démo live, nous analyserons uniquement la",
        "first page": "première page",
        "of your document and we don't save your file during processing. Read more about our": "de votre document et nous n'enregistrons pas votre fichier pendant le traitement. En savoir plus sur notre",
        "Privacy Data Policy GDPR": "Politique de confidentialité des données RGPD",
        "Start a free trial": "Commencez un essai gratuit",
        "Contact a sales team": "Contacter une équipe commerciale",
        "radius": "rayon",
        "Activate": "Activer",
        "Add blur to the image": "Ajouter du flou à l'image",
        "Transforms the image into a 3 channels greyscale image": "Transforme l'image en une image en niveaux de gris à 3 canaux",
        "Add basics folds to the image based of predefined folds images": "Ajouter des plis de base à l'image sur la base d'images de plis prédéfinis",
        "Add a vintage effect to the documents": "Ajouter un effet vintage aux documents",
        "upperValue": "valeur_supérieure",
        "lowerValue": "valeur inférieure",
        "Add salt and papper noise to the image": "Ajouter du bruit de sel et de papier à l'image",
        "Var": "Var",
        "Mean": "Moyenne",
        "(float > 0): the normalized mean of noise": "(float > 0) : la moyenne normalisée du bruit",
        "The normalized variance of noise": "La variance normalisée du bruit",
        "Add gaussian noise to RGB channels independently": "Ajouter du bruit gaussien aux canaux RVB indépendamment",
        "Factor to create shading: 1 - black line along the fold, 0 - no change": "Facteur pour créer un ombrage : 1 - ligne noire le long du pli, 0 - pas de changement",
        "Shade factor": "Facteur d'ombre",
        "Alpha": "Alpha",
        "Decay rate": "Taux de décomposition",
        "(int > 0): decay for shading effect (number of pixels)": "(int > 0) : Décroissance pour l'effet d'ombrage (nombre de pixels)",
        "Num folds": "Nombre de plis",
        "(int > 0): the number of folds to be added to the image alpha (float [0-1]): weight factors to introduce deformations (better to take from 0.01 to 0.1)": "(int > 0) : le nombre de plis à ajouter à l'image alpha (float [0-1]) : facteurs de pondération pour introduire des déformations (mieux vaut prendre de 0.01 à 0.1)",
        "Add 3D and shading": "Ajouter de la 3D et de l'ombrage",
        "(int): the number of iterations of the ink bleeding loop (WARNING: This degradation is really time consuming: use small values of iterations)": "(entier) : le nombre d'itérations de la boucle de ressuage de l'encre (ATTENTION : Cette dégradation prend beaucoup de temps : utilisez de petites valeurs d'itérations)",
        "Iterations": "Itérations",
        "(float [0-1]): weight of the verso pixel": "(float [0-1]) : poids du pixel verso",
        "Mirror the image, use it as a verso image and 'bleed' the ink into the recto": "Reflétez l'image, utilisez-la comme image verso et « appuyé » l'encre dans le recto",
        "Ink-bleeding": "Encre appuyée",
        "Folds-3d": "Document plié en 3d",
        "Gaussian-noise": "Bruit gaussien",
        "Salt-and-papper": "Papier froissé",
        "Vintage": "Effet veillant",
        "Folds": "Plié un document",
        "Greyscale": "Rajouter du gris",
        "Blur": "Flouttage du document",
        "Effects": "Effets",
        "File Not Uploaded. Upload File less Than 500 KB": "Fichier non téléchargé. Téléchargez un fichier de moins de 500 Ko",
        "Add new effect": "Ajouter un nouvel effet",
        "Blur degradation": "Dégradation du flou",
        "Background URL": "URL d arrière-plan",
        "Create new project": "Créer un nouveau projet",
        "Create new model": "Former un nouveau modèle",
        "Generate new dataset": "Générer un nouveau jeu de données",
        "Upload my own dataset": "Télécharger mon propre jeu de données",
        "Deploy an API": "Déployer une API",
        "Create new labelling": "Créer un nouvel étiquetage",
        "Create new labeling": "Créer un nouvel étiquetage",
        "Add new data store": "Ajouter un nouveau magasin de données",
        "Add User": "Ajouter un utilisateur",
        "Create new Testing": "Créer un nouveau test",
        "Create new scene": "Créer une nouvelle scène",
        "Compare": "Comparer plusieurs modèles",
        "Testings": "Tests",
        "Preview image": "Image d'aperçu",
        "No datasets available": "Aucun jeu de données disponible",
        "No keys available": "Aucune clé disponible",
        "No Users available": "Aucun utilisateur disponible",
        "No inferences accounts available": "Aucun compte d inférences disponible",
        "No requests available": "Aucune demande disponible",
        "No export(s) available": "Aucune exportation disponible",
        "No data stores available": "Aucun magasin de données disponible",
        "No projects available": "Aucun projet disponible",
        "No label available": "Aucune étiquette disponible",
        "No scenes available": "Aucune scène disponible",
        "No inferences available": "Aucune inférence disponible",
        "No revisions available": "Aucune révision disponible",
        "No labels available": "Aucune étiquette disponible",
        "No category available": "Aucune catégorie disponible",
        "No Testings available": "Aucun test disponible",
        "No models available": "Aucun modèle disponible",
        "Train metrics no available": "Mesures d entraînement non disponibles",
        "Test metrics no available": "Mesures de test non disponibles",
        "Evaluation metrics no available": "Métriques d évaluation non disponibles",
        "No info available": "Aucune information disponible",
        "No config available": "Aucune configuration disponible",
        "zoomin": "Agrandir",
        "zoomout": "Dézoomer",
        "reset": "Réinitialiser",
        "fit": "En forme",
        "Object name": "Nom de l'objet",
        "Unskip labelling": "Ne pas ignorer l'étiquetage",
        "Skip labelling": "Ignorer l'étiquetage",
        "Copy link": "Copier le lien",
        "No histories found": "Aucun historique trouvé",
        "Id": "Id",
        "User": "Utilisatrice",
        "Submitted At": "Soumis à",
        "History": "Histoire",
        "Deploy a remote API": "Déployer une API distante",
        "Create Labelling": "Créer l'étiquetage",
        "Submit": "Soumettre",
        "Create dataset": "Créer le jeu de données",
        "Create Preset": "Créer le magasin de données",
        "Create scene": "Créer la scène",
        "Update": "Mettre à jour",
        "Deploy": "Déployer",
        "Create model": "Créer le modèle",
        "Create company": "Créer l'espace de travail",
        "API key": "Clé API",
        "API secret": "Clé secrète de l'API",
        "Last used": "Dernière utilisation",
        "ops": "opérations",
        "FaB": "FaB",
        "User name": "Nom d'utilisateur",
        "Email address": "Adresse e-mail",
        "Last activity": "Dernière activité",
        "resetpassword": "réinitialiser le mot de passe",
        "edit": "Éditer",
        "email": "e-mail",
        "Plan-type": "Type de plan",
        "Request": "Demande",
        "ID": "Identifiant",
        "checkpoint": "point de contrôle",
        "checkpoints": "points de contrôle",
        "Path": "Chemin",
        "Time created": "Date de création",
        "Time processed": "Temps de traitement",
        "no project labelling": "Pas d'étiquetage disponible",
        "Duration": "Durée",
        "Import type": "Source",
        "Images": "Images",
        "Operations": "Opérations",
        "Elements": "Éléments",
        "Labeling": "Étiquetage",
        "Total entities": "Total des entités",
        "Images labeled": "Images étiquetées",
        "view": "voir",
        "Created At": "Date de création",
        "Approved": "Approuvée",
        "Date updated": "Date de mise à jour",
        "Default Image URL": "URL d'image par défaut",
        "Inference Name": "Nom d'inférence",
        "ProjectLabelling": "Étiquetage du projet",
        "Coverage": "Couverture",
        "Time Processing": "Traitement du temps",
        "Training task": "Tâche de formation",
        "Training learner": "Apprenant en formation",
        "Nb epochs": "Nb époques",
        "Batch size": "Taille du lot",
        "loss": "perte",
        "Model name": "Nom du modèle",
        "Backbone name": "Backbone name",
        "Pretrained fpn": "FPN pré-entraîné",
        "updatedAt": "Date de mise à jour",
        "View scenes": "Voir les scènes",
        "View labeling": "Voir l'étiquetage",
        "View": "Voir",
        "Queued": "En file d'attente",
        "Started": "Démarré",
        "Uploaded": "Téléchargé",
        "Running": "En fonctionnement",
        "Doing": "Action",
        "Finished": "Terminé",
        "Processed": "Traité",
        "Failed": "Erreur",
        "Failed System": "Erreur système",
        "Canceled": "Annulé",
        "View all metrics": "Afficher les métriques du point de contrôle",
        "Re Run": "Réexécuter",
        "Manage": "Détail",
        "Update preset": "Mettre à jour le magasin de données",
        "Settings": "Réglage",
        "Make revision": "Faire une révision",
        "Roll back": "Retour en arriere",
        "Accounting": "Comptabilité",
        "Real estate": "Immobilier",
        "documents": "documents",
        "document": "document",
        "Overview": "Aperçu",
        "Users": "Utilisateurs",
        "Confusion": "Confusion",
        "Errors": "Erreurs",
        "Confusion matrix": "Matrice de confusion",
        "Data stores": "Magasins de données",
        "Projects": "Projets",
        "Results": "Résultats",
        "Data": "Données",
        "Heatmap": "Cartes thermiques",
        "Built-in": "Intégré",
        "APIs": "APIs",
        "Editor": "Éditeur",
        "Archive": "Archive",
        "Heatmaps": "Cartes thermiques",
        "Response API": "Réponse JSON",
        "Introduction": "Introduction",
        "Revisions": "Révisions",
        "Monitor": "Moniteur",
        "Requests": "Requêtes",
        "Live Testing": "Test en direct",
        "Accuracy": "Précision",
        "All images": "Toutes les images",
        "Unannotated images": "Images non annotées",
        "Skipped images": "Images ignorées",
        "Approved images": "Images approuvées",
        "Disapproved images": "Images refusées",
        "Account": "Compte",
        "Accounts": "Comptes",
        "Knowledge Vision": "Formation",
        "Inferencia": "Déploiement",
        "Auto labelling": "Étiquetage automatique",
        "Compare metrics": "Comparer les métriques",
        "Next: API": "Étape suivante : API",
        "Next: Tags": "Étape suivante : Balises",
        "Next: Preview": "Étape suivante : Aperçu",
        "Prev: Documents": "Étape précédente : Documents",
        "Prev: API": "Étape précédente : API",
        "Prev: Tags": "Étape précédente : Balises",
        "Next: Type of dataset": "Étape suivante : Tâche",
        "Next: Labelling data": "Étape suivante : Étiquetage des données",
        "Next: Synthetic data": "Étape suivante : Données synthétiques",
        "Next: Capacity management": "Étape suivante : Gestion de la capacité",
        "Prev: Description": "Étape précédente : Description",
        "Prev: Type of dataset": "Étape précédente : Tâche",
        "Prev: Labelling data": "Étape précédente : Étiquetage des données",
        "Prev: Synthetic data": "Étape précédente : Données synthétiques",
        "Prev: Capacity management": "Étape précédente : Gestion de la capacité",
        "Next: Data store": "Étape suivante : magasin de données",
        "Next: Preset": "Étape suivante : Préréglage",
        "Next: Task": "Étape suivante : Tâche",
        "Prev: Task": "Étape précédente : Tâche",
        "Next page": "Page suivante",
        "Prev page": "Page précédente",
        "Download image": "Télécharger",
        "Next: Background": "Étape suivante : Contexte",
        "Next: Path": "Étape suivante : Chemin",
        "Next: Models": "Étape suivante : Modèles",
        "Next: Post-processing": "Étape suivante : Post-traitement",
        "Next: Security": "Étape suivante : Sécurité",
        "Next: Testing": "Étape suivante : Tests",
        "Prev: Path": "Étape précédente : Chemin",
        "Prev: Models": "Étape précédente : Modèles",
        "Prev: Post-processing": "Étape précédente : Post-traitement",
        "Prev: Security": "Étape précédente : Sécurité",
        "Prev: Testing": "Étape précédente : Tests",
        "Next: Function": "Étape suivante : Fonction",
        "Next: Enviornment variables": "Étape suivante : Variables d'environnement",
        "Next: Dashboard configuration": "Étape suivante : Configuration du tableau de bord",
        "Prev: Function": "Étape précédente : Fonction",
        "Prev: Enviornment variables": "Étape précédente : Variables d'environnement",
        "Prev: Dashboard configuration": "Étape précédente : Configuration du tableau de bord",
        "Next: Configuration": "Étape suivante : Configuration",
        "Prev: Configuration": "Étape précédente : Configuration",
        "Next: Dataset": "Étape suivante : Jeu de données",
        "Next: Transfer learning": "Étape suivante : Apprentissage par transfert",
        "Prev: Template": "Étape précédente : Modèle",
        "Prev: Dataset": "Étape précédente : Jeu de données",
        "Prev: Transfer learning": "Étape précédente : Apprentissage par transfert",
        "Next: Members": "Étape suivante : Membres",
        "Prev: Members": "Étape précédente : Membres",
        "Oops...": "Oups...",
        "This page could not be found.": "Cette page est introuvable.",
        "Loading Dataset": "Chargement des jeux de données",
        "Loading data-stores": "Chargement des magasins de données",
        "Loading items": "Chargement des éléments",
        "Loading confusion matrix": "Chargement de la matrice de confusion",
        "Loading metrics": "Chargement des métriques",
        "Loading companies": "Chargement des espaces de travail",
        "2 hours": "2 heures",
        "30 minutes": "30 minutes",
        "4 hours": "4 heures",
        "7 hour": "7 heures",
        "3 day": "3 jours",
        "2 week": "2 semaines",
        "Create": "Créer",
        "Playground": "Test",
        "Please add": "S'il-vous-plait ajouter",
        "or select object": "ou sélectionnez un objet",
        "Already have an account?": "Vous avez déjà un compte?",
        "connexion": "Connexion",
        "Resend confirmation email": "Renvoyer un nouveau lien de confirmation",
        "We have sent you a confirmation email. Please check it to finalize your registration.": "Nous vous avons envoyé un email de confirmation. Veuillez le consulter pour finaliser votre inscription.",
        "emailused": "Désolé, l'adresse email que vous avez entrée est déjà utilisée. Veuillez en entrer une nouvelle ou connectez-vous si vous avez déjà un compte.",
        "By signing up, I accept the": "En m'inscrivant, j'accepte les",
        "Terms and Conditions": "Termes et conditions",
        "and": "et",
        "Privacy Policy": "Politique de confidentialité",
        "Email required.": "Email requis.",
        "Last name too short": "Nom de famille trop court",
        "Last name too long": "Nom de famille trop long",
        "First name too long": "Prénom trop long",
        "First name too short": "Prénom trop court",
        "Sign up": "S'inscrire",
        "Password": "Mot de passe",
        "Try Wikibank Platform for free: no commitment, no credit card required.": "Essayez la plateforme Wikibank gratuitement : sans engagement, sans carte de crédit.",
        "© Copyright": "© Droit d'auteur",
        "Sign up with Microsoft": "Inscrivez-vous avec Microsoft",
        "Sign up with Google": "S'inscrire avec Google",
        "Confirmation email not sent, please try again.": "E-mail de confirmation non envoyé, veuillez réessayer.",
        "We will send a recovery link to your email": "Nous enverrons un lien de récupération à votre adresse e-mail",
        "required": "obligatoire",
        "contactSupport": "Contactez le support",
        "Send link": "M'envoyer un lien",
        "Oops, User not found!": "Oups, utilisateur introuvable !",
        "signup": "s'inscrire",
        "images labelled": "étiquetées",
        "not images labeled(s)": "non étiquetées",
        "images skipped": "ignorées",
        "images skipped": "ignorées",
        "not images labeled(s)": "non étiquetées",
        "images labelled": "étiquetées",
        "enterEmail": "entrer votre email",
        "Compte validé!": "Compte validé!",
        "AUTH-000": "Afin de valider votre compte, veuillez suivre le lien de confirmation que nous avons envoyé à l'adresse email associée à votre compte. Si vous n'avez pas reçu ce lien, veuillez vérifier vos courriers indésirables.",
        "All companies": "Aller vers tous les espaces de travail",
        "No logs available": "Aucun journal disponible",
        "resultEmptyExtenxion": "resultEmptyExtension",
        "Validation de votre compte": "Validation de votre compte",
        "Profile": "Profil",
        "Change password": "Modifier le mot de passe",
        "API Keys": "Clés API",
        "Old password": "Ancien mot de passe",
        "Confirm new password": "Confirmer le nouveau mot de passe",
        "New password": "Nouveau mot de passe",
        "First name": "Prénom",
        "codevalidate": "Félicitations, votre compte a été validé avec succès! Vous allez être redirigé vers la page de connexion dans 5 secondes.",
        "codevalidate no validate": "Désolé, votre compte n'a pas pu être validé. Veuillez contacter l'administrateur pour plus d'informations.",
        "Confirm new password required.": "Confirmer le nouveau mot de passe requis.",
        "Old password required.": "Ancien mot de passe requis.",
        "New password required.": "Nouveau mot de passe requis.",
        "Password required.": "Mot de passe requis.",
        "My APIs": "Mes APIs personnalisées",
        "For Account ID": "Pour le compte ID",
        "notificationType": "type de notification",
        "notificationURL": "URL de notification",
        "Retention": "Rétention",
        "Add key": "Ajouter une nouvelle clé",
        "Update my company": "Mettre à jour mon entreprise",
        "Update my profile": "Mettre à jour mon profil",
        "Company name": "Nom de l'entreprise",
        "address": "Adresse",
        "country": "Pays",
        "Update project": "Mettre à jour le projet",
        "Loading analytics": "Chargement des analyses",
        "Loading model detail": "Chargement des détails du modèle",
        "companies": "Espaces de travail",
        "waitNetork": "En attente de connexion internet...",
        "Home": "Accueil",
        "Analytics Item": "Élément d'analyse",
        "Table extraction": "Extraction de table",
        "field": "Champs",
        'Auto checking submitted sucessfully.': 'Vérification automatique soumise avec succès.',
        "Auto checking": "Vérification automatique",
        "Auto Checking": "Vérification automatique",
        "Start auto-checking": "Démarrer la vérification automatique",
        "Auto checking is disable because it's already in progress.": "La vérification automatique est désactivée car elle est déjà en cours.",
        "Inferences Account": "Compte d'inférences",
        'choicePassword': 'Choisir un mot de passe',
        'choiceNewPassword': 'choixNouveauMotDePasse',
        'Dashboard (beta)': 'Tableau de bord (bêta)',
        'New Label': 'Nouvelle étiquette',
        'New Scene': 'Nouvelle scène',
        'Upload Dataset': 'Télécharger un jeu de données',
        'newprocess': 'nouveauprocessus',
        'Datalabs': 'Datalabs',
        'Pacman - Playground': 'Pacman - Aire de jeux',
        'Matrix Train': 'Train matriciel',
        'New model': 'Nouveau modèle',
        'Inferences': 'Inférences',
        'Inference Account': 'Compte d\'inférence',
        'Inference': 'Inférence',
        "Select a “classification” type in case you want to identify the “class’ your images fall under.": "Sélectionner un type de « classification » au cas où vous voudriez identifier la « classe » de vos images.",
        "Actions": "Actions",
        "JSON": "JSON",
        'Processing': 'Traitement',
        "Loading image": "Chargement de l'image",
        'Loading API(s)': 'Chargement des APIs',
        'Loading admin(s)': 'Chargement des administrateurs',
        "Loading": "Chargement",
        'Loading Request(s)': 'Chargement des traitements',
        "Loading metrics": "Chargement des métriques",
        'Loading Heatmap': 'Chargement de la carte thermique',
        "Scanning projects scenes": "Numérisation des scènes",
        'Loading projects': 'Chargement des projets',
        "Loading category": "Chargement de la catégorie",
        'Loading Testing(s)': 'Chargement des tests',
        'Loading model(s)': 'Chargement des modèles',
        'Loading checkpoint metric(s)': 'Chargement des métriques de point de contrôle',
        'Loading checkpoint(s)': 'Chargement des points de contrôle',
        'Loading logs': 'Chargement des journaux',
        'Loading monitor': 'Chargement des données du moniteur',
        'loading': 'Chargement en cours',
        'Annotated': 'Annoté',
        'Unannotated': 'Non annoté',
        'Skipped': 'Ignoré',
        'Unapproved': 'Désapprouvé',
        'Approved': 'Approuvé',
        'Comments': 'Commentaires',
        'Auto-labelling': 'Étiquetage automatique',
        'Auto labelling': 'Étiquetage automatique',
        'Auto checking': 'Vérification automatique',
        'Ready to use': 'Prêt à l\'emploi',
        'For demonstation': 'Pour démonstration',
        'haveAdminRole': 'avoirAdminRole',
        "Auto Labeling": "Étiquetage automatique",
        'New Project': 'Nouveau projet',
        'New Data store': 'Nouveau magasin de données',
        'New Dataset': 'Nouvel ensemble de données',
        'New scene': 'Nouvelle scène',
        'New Labelling': 'Nouvel étiquetage',
        'New testing': 'Nouveau test',
        'New company': 'Nouvel espace de travail',
        'New inference': 'Nouvelle inférence',
        'New inference account': 'Nouveau compte d\'inférence',
        'Upload text file': 'Téléchargez le fichier texte',
        'Upload image': 'Télécharger une image',
        'Upload images': 'Importer des images',
        "Upload file": "Téléverser un fichier",
        "image": "image",
        "text": "texte",
        '1_day': 'Un jour',
        '3_day': '3 jours',
        '1_week': '1 semaine',
        '2_week': '2 semaines',
        '1_month': '1 mois',
        '1_year': '1 année',
        '12_hours': '12 heures',
        "4 columns": "4 colonnes",
        "3 columns": "3 colonnes",
        "2 columns": "2 colonnes",
        'Auto-checking': 'Vérification automatique',
        'Edit user': 'Modifier l\'utilisateur',
        "Select language": "Choisir la langue",
        "Admin": "Administrateur",
        "Train your first model with differents approachs, document entities or classification task faster.": "Entraîner votre premier modèle avec différentes approches, plus rapidement.",
        "Create your first model": "Créez votre premier modèle",
        "No data found": "Aucune donnée disponible",
        "Apply request": "WikiBox",
        "Generate your dataset from projects labelling or scenes": "Générer votre jeu de données à partir d'étiquetage de projets ou de scènes",
        "Generate your first dataset": "Générer votre premier jeu de données",
        "Prepare your raw datastore images for your future projects labelling on detection or classification task": "Préparer vos images brutes de votre magasin de données pour vos futurs projets d'étiquetage sur une tâche de détection ou de classification",
        "Create your first preset": "Créer votre premier préréglage",
        "Start labelling or generate synthetic data from from your presets data store": "Commencer à étiqueter ou générer des données synthétiques à partir de votre magasin de données de préréglages",
        "Create your first project": "Créer votre premier projet",
        "Deploy your first inference API on production with models": "Déployez votre première API d'inférence en production avec des modèles",
        "Deploy your first inference": "Déployer votre première inférence",
        "add first testing for your model, document entities or classification task faster.": "Ajouter plus rapidement vos premiers tests automatisées pour votre modèle, vos entités ou votre tâche de classification.",
        "Create your first Testing": "Créer votre premier test",
        "*Adding an testing name is a required field.": "*L'ajout d'un nom de test est un champ obligatoire.",
        'User edited!': 'Utilisateur modifié !',
        "French": "Français",
        "English": "Anglais",
        "Next: Capacity Machine": "Étape suivante : capacité de la machine",
        "Prev: Model": "Étape précédente : Modèle",
        'Step 1. Model': 'Étape 1. Modèle',
        'Step 2. Capacity Machine': 'Étape 2. capacité de la machine',
        'Capacity Machine': 'capacité de la machine',
        'Bank': 'Banque',
        'KYC': 'KYC',
        'Other': 'Autre',
        'Tax': 'Impôt',
        'public-Inference': 'Inférence publique',
        'Inferences model': 'Modèle d\'inférences',
        'Pre-trained model': 'Modèle pré-formé',
        'heatmaps': 'cartes thermiques',
        'Request item': 'Objet de la demande',
        'Comparison metrics': 'Métriques de comparaison',
        'Comparison confusion matrix': 'Matrice de confusion de comparaison',
        'Edit company': 'Modifier l\'espace de travail',
        'Edit inference': 'Modifier l\'inférence',
        'admin': 'administrateur',
        'Edit inference account': 'Modifier le compte d\'inférence',
        'web-view': 'vue Web',
        'Document processed': 'Traitement',
        "columns": "Colonnes",
        'Total': 'Totale',
        'In use:': 'Utilisé:',
        'Last use:': 'Dernière utilisation :',
        'analytics': 'analytique',
        "Images not labeled": "Images non étiquetées",
        "Images skipped": "Images ignorées",
        "STARTED": "A DÉBUTÉ",
        "FINISHED": "TERMINÉ",
        "QUEUED": "EN FILE D'ATTENTE",
        "PROCESSED": "TRAITÉ",
        "FAILED": "MANQUÉE",
        "CANCELED": "ANNULÉ",
        "FAILED SYSTEM": "SYSTÈME DÉFECTUEUX",
        "DOING": "EN COURS",
        "running": "En cours",
        "SUBMITTED": "ENVOYÉE",
        "Submitted": "Envoyée",
        "WAITING": "EN ATTENTE",
        "Waiting": "En attente",
        "UPLOADED": "TÉLÉCHARGÉ",
        "Complete registration": "Confirmez votre compte.",
        "pleasenotusegmail": "Veuillez utiliser une adresse e-mail professionnelle pour ouvrir un compte.",
        "Labeled(s)": "Étiqueté(s)",
        "Not Labeled(s)": "Non étiqueté(s)",
        "Skip Labeled(s)": "Ignorer le(s) libellé(s)",
        'Unlimited': 'Illimité',
        'Pre-trained': 'Pré-formé',
        'General': 'Général',
        '5 days': '5 jours',
        '2 weeks': '2 semaines',
        '1 year': '1 année',
        '15 minutes': '15 minutes',
        'Rename': 'Renommer',
        'Skip': 'Retirer',
        'general': 'général',
        "pretrained": "préformé",
        'Financial': 'Financier',
        "Not available": "Pas disponible",
        ' checkpoint(s)': ' point(s) de contrôle',
        "Naming": "Appellation",
        "Allow items": "Autorisation",
        "Dataset imported (101)": "Jeu de données importé (101)",
        "Yes": "Oui",
        'No': 'Non',
        'favorite': 'Favoris',
        'If you create project labelling with create snap of preset you are sure to continue ?': 'Si vous créez un étiquetage de projet avec créer un snap de préréglage, vous êtes sûr de continuer ?',
        'display': 'affichage',
        'Confirmation': 'Confirmation',
        'Back': 'Arrière',
        'key is required*': 'la clé est requise*',
        'value is required*': 'valeur est requise*',
        "Key": "Clé",
        'Upload': 'Télécharger',
        'Trigger immediality model training when dataset finished with simple configuration.': "Déclencher immédiatement la formation d'un modèle lorsque le jeu de données sera terminé avec une simple configuration.",
        'Step 6. Pre configuration': 'Étape 6. Pré-configuration',
        'Preconfig': 'Préconfiguration',
        'Step 9. Preview': 'Étape 9. Aperçu',
        "Request API": "Requête HTTPS",
        "Display Name French": "Nom d'affichage en français",
        "Description French": "Descriptif en français",
        "Reporting": "Rapports",
        "Visualization": "Visualisation",
        "Status ": "Statuts",
        'Cancel upload': 'Annuler le téléchargement',
        'Uploading...': 'Téléchargement...',
        'Files were uploaded successfully': 'Les fichiers ont été téléchargés avec succès',
        'PDF files splited': 'Fichiers PDF divisés',
        'Files are not supported': 'Fichiers n\'ont pris en charge',
        'Files were not uploaded': 'Fichiers n\'ont téléchargés',
        'Files are saved': 'Fichiers enregistrés',
        'Files are removed': 'Fichiers supprimés',
        "Information": "Informations",
        "New Comment": "Nouveau commentaire",
        '🤖 Documents does not exist because this request is failed': '🤖 Aucune analyse disponible car cette traitement a échoué',
        "+ Add new Tag": "+ Ajouter une nouvelle balise",
        'Step 6. Dashboard configuration': 'Étape 6. Configuration du tableau de bord',
        'Step 7. Testing': 'Étape 7. Test',
        'Step 8. Capacity management': 'Étape 8. Gestion de la capacité',
        "requests in last 30 days": "Traitement de données au cours des 30 derniers jours",
        "Models and inferences": "Modèles et inférences",
        "projects and datasets": "projets et jeux de données",
        "inferences": "inférences",
        "total models with": "Modèles IA lancés produisant au total",
        "dataset": "jeux de données générés",
        "projects": "projets",
        "Display": "Afficher",
        "Step 4. Tags": "Étape 4. Balises",
        "Step 5. Preview": "Étape 5. Aperçu",
        "Historic Data": "Historique de l'espace de travail",
        "total projects with": "Projets crées produisant au total",
        "total projects with": "Projets avec",
        "Deploy a flow API": "Déployer une API processus",
        "Add Flow": "Ajouter un processus",
        "Add Comment": "Ajouter un commentaire",
        "Validation": "Validations",
        "Add new comment": "Ajouter un commentaire",
        "Success": "Succès",
        "Error": "Erreur",
        "Warning": "Avertissement",
        "Validation Link": "Validations croisées",
        "Validation Node": "Validations internes",
        "To Comment": "Commenté",
        "Request Number": "ID",
        "Flow Configuration.": "Configurer votre processus pour votre API.",
        "Step 3. Flow": "Étape 3. Configuration du processus",
        "Update flow": "Mettre à jour le processus",
        "Deploy flow": "Déployer le processus",
        "Relative Metrics": "Mesures relatives",
        "Absolute Metrics": "Mesures absolues",
        "Absolute Accuracy": "Précision absolue",
        "Relative Accuracy": "Précision relative",
        "Average per image": "Moyenne par image",
        "Average per field": "Moyenne par champ",
        "Average column": "Moyenne par image",
        "Average line": "Moyenne par champ",
        "List of entities": "Liste des entitiés",
        "List of classes": "Liste des class autorisées",
        "Merge": "Fusionner",
        "Text spacing": "Espacement",
        "Validation Checked": "Validations masquées",
        "Checklists": "Checklist",
        "Activity": "Activité",
        "Filename": "Nom du fichier",
        "Updated At": "Mise à jour",
        "Created At": "Création",
        "Data": "Données",
        "Priorities": "Priorités",
        "priority": "Priorité",
        "API and export": "API et exportation",
        "Inbound email": "E-mail entrant",
        "Add Priorities": "Ajouter une priorité",
        "Add Checklists": "Ajouter un point de contrôle",
        "Select priority": "Sélectionnez une priorité",
        "No checklist available": "Aucune liste de contrôle disponible",
        "Total pages": "Pages",
        "Fields": "Champs",
        "Fields warning": "Champs Warning",
        "Validation": "Validation",
        "Manual updates": "Transcription",
        "Dynamic Name": "Nom dynamique",
        "Change priority": "Modifier la priorité",
        "Not specified" : "Non renseigné",
        "Application" : "Application",
        "Message": "Message",
        "Mark as see":"Marquer comme vu",
        "Validation Node" :"Nœud de validation",
        "Change category":"Modifier la catégorie",
        "Change state":"Modifier l'état",
        "Merge document":"Fusionner le document",
        "Add document":"Ajouter un document",
        "Validations":"Validations",
        "Developers":"Développeurs",
        "Loan":"Finance",
        "Identity":"Identité",
        "No documents available":"Aucun document disponible",
        "Stats":"Statistiques",
        "Change Category":"Modifier la catégorie",
        "Change Stats":"Modifier les statistiques",
        "Graph":'Graphique',
        "Document Type":"Type de document",
        "Alerts":"Alertes",
        "Submit Pre request":"Envoyer une pré-demande",
        "Default life time for link":"Durée de vie par défaut du lien",
        "select life time for link":"sélectionner la durée de vie du lien",
        "January":"Janvier",
        "February":"Février",
        "Operation update": "Appliquer des modifications",
        "March":"Mars",
        "April":"Avril",
        "June":"Juin",
        "July":"Juillet",
        "August":"Août",
        "September":"Septembre",
        "October":"Octobre",
        "November":"Novembre",
        "December":"Décembre",
        "Year":"An",
        "Month":"Mois",
        "Documents in":"Documents en",
        "Pages in":"Pages dans",
        "This month": "Ce mois",
        "Last week": "Semaine dernière",
        "Last month": "Mois dernier",
        "Last 3 months": "3 derniers mois",
        "Last 12 years": "12 derniers mois",
}

export default message
/* eslint no-use-before-define: 2 */



// WEBPACK FOOTER //
// ./src/utils/translate-fr.js